<mat-horizontal-stepper [linear]="true" #stepper class="ps h-full product-images-viewer">
  <mat-step *ngIf="priceList.use3d">
    <model-viewer
      class="h-full w-full min-h-full min-w-full"
      [environmentImage]="'neutral'"
      #viewer
      [src]="modelUrl"
      preload
      alt="A 3D model"
      [exposure]="exposure"
      camera-controls>
    </model-viewer>

    <div class="info-panel flex flex-row justify-center items-center">
      <button
        mat-icon-button
        color="accent"
        i18n-matTooltip
        matTooltip="Просмотр 3D модели"
        (click)="showProductModel()"
        *ngIf="priceList.use3d">
        <mat-icon>3d_rotation</mat-icon>
      </button>
    </div>

    <button class="nav-btn next-btn" mat-button matStepperNext>
      <mat-icon class="s-50">arrow_forward_ios</mat-icon>
    </button>
  </mat-step>

  <mat-step *ngIf="imagePaths.length === 0">
    <div
      class="grey-100 no-image-icon-wrapper flex flex-col justify-center items-center h-full w-full min-h-full min-w-full">
      <img src="{{ getProductPreviewPath(productId) }}" />
    </div>

    <button *ngIf="priceList.use3d" class="nav-btn prev-btn" mat-button matStepperPrevious>
      <mat-icon class="s-50">arrow_back_ios</mat-icon>
    </button>

    <button *ngIf="imagePaths.length > 0" class="nav-btn next-btn" mat-button matStepperNext>
      <mat-icon class="s-50">arrow_forward_ios</mat-icon>
    </button>
  </mat-step>

  <mat-step *ngFor="let item of imagePaths; index as i">
    <div class="flex flex-col justify-center items-center h-full w-full min-h-full min-w-full">
      <img src="{{ getPathToTexture(item) }}" />
    </div>

    <button class="nav-btn prev-btn" mat-button matStepperPrevious>
      <mat-icon class="s-50">arrow_back_ios</mat-icon>
    </button>
    <button *ngIf="i < imagePaths.length - 1" class="nav-btn next-btn" mat-button matStepperNext>
      <mat-icon class="s-50">arrow_forward_ios</mat-icon>
    </button>
  </mat-step>
</mat-horizontal-stepper>
